/* Films GLINT : source unique, lecture visible et pause utilisateur conservée. */
(() => {
  const selector = '[data-glint-hero-video], [data-glint-reflekta] video';

  function initManual(video) {
    const hero = video.hasAttribute('data-glint-hero-video');
    const mobile = matchMedia('(max-width: 749px)');
    const language = document.documentElement.lang.slice(0, 2);
    const labels = { fr: 'Lire la vidéo', en: 'Play video', de: 'Video abspielen', nl: 'Video afspelen', es: 'Reproducir vídeo', it: 'Riproduci video' };
    const sources = [...video.querySelectorAll('source')].map(source => ({ source, src: source.getAttribute('src') }));
    const originalSrc = video.getAttribute('src');
    // No decoder/source is initialized until a visitor explicitly presses play.
    sources.forEach(item => item.source.removeAttribute('src'));
    video.removeAttribute('src');
    video.removeAttribute('autoplay');
    video.preload = 'none';
    video.muted = video.defaultMuted = true;
    video.playsInline = true;
    video.controls = false;
    video.loop = false;
    if (hero) video.poster = mobile.matches ? video.dataset.posterMobile : video.dataset.posterDesktop;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'glint-media-start';
    button.setAttribute('aria-label', labels[language] || labels.en);
    button.innerHTML = '<svg width="20" height="24" viewBox="0 0 20 24" aria-hidden="true"><path fill="currentColor" d="M2 1L20 12 2 23Z"/></svg>';
    video.parentElement.appendChild(button);
    let started = false;
    button.addEventListener('click', () => {
      if (!started) {
        if (hero) video.src = mobile.matches ? video.dataset.mobile : video.dataset.desktop;
        else {
          if (originalSrc) video.src = originalSrc;
          sources.forEach(item => { if (item.src) item.source.src = item.src; });
        }
        started = true;
        video.removeAttribute('aria-hidden');
        video.removeAttribute('tabindex');
        video.controls = true;
        video.load();
      }
      button.hidden = true;
      video.play().catch(() => { button.hidden = false; });
    });
    video.addEventListener('ended', () => { button.hidden = false; });
    const pauseHidden = () => { if (document.hidden) video.pause(); };
    document.addEventListener('visibilitychange', pauseHidden);
    const observer = new IntersectionObserver(entries => {
      if (!entries[0].isIntersecting) video.pause();
    });
    observer.observe(video);
    video.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
      observer.disconnect();
      document.removeEventListener('visibilitychange', pauseHidden);
      video.pause();
    }, { once: true });
  }

  function init(video) {
    if (video.dataset.filmBound) return;
    video.dataset.filmBound = 'true';
    if (document.documentElement.classList.contains('glint-ios-media-manual')) {
      initManual(video);
      return;
    }
    const hero = video.hasAttribute('data-glint-hero-video');
    const reflekta = !!video.closest('[data-glint-reflekta]');
    const mobile = hero ? matchMedia('(max-width: 749px)') : null;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection;
    const section = video.closest('.shopify-section');
    let coveringSection = hero ? section?.nextElementSibling : null;
    while (coveringSection && !coveringSection.matches('.shopify-section')) {
      coveringSection = coveringSection.nextElementSibling;
    }
    let wantsPlayback = !reduced.matches && !connection?.saveData;
    let inView = false;
    let covered = false;
    let disposed = false;
    let currentSource = '';
    let automaticPauses = 0;
    let playRequest = 0;
    let observer;
    let visibilityFrame = 0;

    video.muted = true;
    video.loop = hero || reflekta;
    video.controls = !reflekta && (!hero || !wantsPlayback);
    video.preload = 'none';

    function pauseForPage() {
      playRequest++;
      if (video.paused) return;
      /* L'événement pause est asynchrone : ne pas le confondre avec un clic. */
      automaticPauses++;
      video.pause();
    }
    function setSource() {
      if (!hero || disposed) return;
      const src = mobile.matches ? video.dataset.mobile : video.dataset.desktop;
      if (!src || src === currentSource) return;
      pauseForPage();
      currentSource = src;
      video.src = src;
    }
    function showControls() {
      /* REFLEKTA est un film décoratif : un refus laisse son image fixe. */
      if (disposed || reflekta) return;
      video.controls = true;
      /* Une source est nécessaire pour lancer manuellement le lecteur natif. */
      setSource();
    }
    function sync() {
      if (disposed) return;
      updateCoverage();
      if (!wantsPlayback || !inView || covered || document.hidden || video.ended) {
        pauseForPage();
        return;
      }
      setSource();
      if (!video.paused) return;
      const request = ++playRequest;
      video.play().catch(error => {
        if (disposed || request !== playRequest || error.name === 'AbortError') return;
        wantsPlayback = false;
        showControls();
      });
    }
    function updateFormat() {
      if (disposed) return;
      if (hero) {
        video.poster = mobile.matches ? video.dataset.posterMobile : video.dataset.posterDesktop;
        if (video.controls) setSource();
      }
      sync();
    }
    function updatePreference() {
      if (disposed) return;
      if (reduced.matches || connection?.saveData) {
        wantsPlayback = false;
        showControls();
      }
      sync();
    }
    function onPlay() {
      if (disposed) return;
      if (!inView || covered || document.hidden || (reflekta && (reduced.matches || connection?.saveData))) {
        pauseForPage();
        return;
      }
      /* Le lecteur natif permet une lecture volontaire malgré RM/Save Data. */
      wantsPlayback = true;
    }
    function onPause() {
      if (disposed) return;
      if (automaticPauses) {
        automaticPauses--;
      } else if (inView && !document.hidden) {
        wantsPlayback = false;
      }
    }
    function onEnded() {
      if (!disposed && !hero && !reflekta) wantsPlayback = false;
    }
    function onError() {
      if (disposed) return;
      wantsPlayback = false;
      showControls();
    }
    function updateCoverage() {
      covered = false;
      if (!coveringSection || getComputedStyle(section).position !== 'sticky') return;
      /* Le hero reste dans le viewport sous ses frères opaques : IO seul ne
         détecte pas ce recouvrement. Le premier frère marque leur frontière. */
      const rect = video.getBoundingClientRect();
      const visibleBottom = Math.min(rect.bottom, innerHeight, coveringSection.getBoundingClientRect().top);
      covered = rect.height > 0 && (visibleBottom - Math.max(rect.top, 0)) / rect.height < 0.15;
    }
    function scheduleVisibility() {
      if (disposed || visibilityFrame) return;
      visibilityFrame = window.requestAnimationFrame(() => {
        visibilityFrame = 0;
        sync();
      });
    }
    function updateVisibility() {
      if (disposed) return;
      const rect = video.getBoundingClientRect();
      const width = Math.max(0, Math.min(rect.right, innerWidth) - Math.max(rect.left, 0));
      const height = Math.max(0, Math.min(rect.bottom, innerHeight) - Math.max(rect.top, 0));
      inView = rect.width > 0 && rect.height > 0 && width * height / (rect.width * rect.height) >= 0.15;
      sync();
    }

    video.addEventListener('play', onPlay);
    video.addEventListener('pause', onPause);
    video.addEventListener('ended', onEnded);
    video.addEventListener('error', onError);
    document.addEventListener('visibilitychange', sync);
    mobile?.addEventListener('change', updateFormat);
    reduced.addEventListener('change', updatePreference);
    connection?.addEventListener?.('change', updatePreference);
    if (coveringSection) {
      /* Capture couvre aussi le scroll interne .page-wrapper sur ordinateur. */
      window.addEventListener('scroll', scheduleVisibility, { passive: true, capture: true });
      window.addEventListener('resize', scheduleVisibility);
    }
    updateFormat();
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        if (disposed || !entries.length) return;
        const entry = entries[entries.length - 1];
        inView = entry.isIntersecting && entry.intersectionRatio >= 0.15;
        sync();
      }, { threshold: 0.15 });
      observer.observe(video);
    } else {
      window.addEventListener('scroll', updateVisibility, { passive: true });
      window.addEventListener('resize', updateVisibility);
      updateVisibility();
    }
    section?.addEventListener('shopify:section:unload', () => {
      disposed = true;
      pauseForPage();
      observer?.disconnect();
      video.removeEventListener('play', onPlay);
      video.removeEventListener('pause', onPause);
      video.removeEventListener('ended', onEnded);
      video.removeEventListener('error', onError);
      document.removeEventListener('visibilitychange', sync);
      mobile?.removeEventListener('change', updateFormat);
      reduced.removeEventListener('change', updatePreference);
      connection?.removeEventListener?.('change', updatePreference);
      if (visibilityFrame) window.cancelAnimationFrame(visibilityFrame);
      window.removeEventListener('scroll', scheduleVisibility, true);
      window.removeEventListener('resize', scheduleVisibility);
      window.removeEventListener('scroll', updateVisibility);
      window.removeEventListener('resize', updateVisibility);
    }, { once: true });
  }
  document.querySelectorAll(selector).forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll(selector).forEach(init));
})();

/* Entrée typographique indépendante du film : le texte reste toujours visible. */
(() => {
  const selector = '[data-glint-editorial]';

  function initHeading(root) {
    if (root.dataset.headingMotionBound) return;
    root.dataset.headingMotionBound = 'true';
    const headings = [...root.querySelectorAll('.glint-editorial__heading h1, .glint-editorial__heading p')];
    const section = root.closest('.shopify-section');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const animations = [];
    let observer;
    let started = false;
    let finished = false;

    function finish() {
      if (finished) return;
      finished = true;
      animations.forEach(animation => animation.cancel());
      observer?.disconnect();
      reduced.removeEventListener('change', onPreference);
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('scroll', finish, true);
      window.removeEventListener('wheel', finish, true);
      window.removeEventListener('pointerdown', finish, true);
      window.removeEventListener('keydown', finish, true);
      window.removeEventListener('resize', finish);
      window.removeEventListener('pagehide', finish);
      section?.removeEventListener('shopify:section:unload', finish);
    }
    function onPreference() { if (reduced.matches) finish(); }
    function onVisibility() { if (document.hidden) finish(); }
    function enter() {
      if (started || finished) return;
      started = true;
      if (reduced.matches || document.hidden || !headings.length || headings.some(heading => !heading.animate)) {
        finish();
        return;
      }
      try {
        headings.forEach((heading, index) => {
          /* Aucun opacity:0, masque ni attente média : seule la position bouge. */
          const animation = heading.animate([
            { transform: `translate3d(0,${index ? 8 : 10}px,0)` },
            { transform: 'translate3d(0,0,0)' }
          ], { duration: 420, delay: index * 50, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
          animations.push(animation);
          animation.finished.catch(() => {});
        });
        Promise.all(animations.map(animation => animation.finished.catch(() => {}))).then(finish);
      } catch (_) { finish(); }
    }

    reduced.addEventListener('change', onPreference);
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('scroll', finish, { passive: true, capture: true });
    window.addEventListener('wheel', finish, { passive: true, capture: true });
    window.addEventListener('pointerdown', finish, { passive: true, capture: true });
    window.addEventListener('keydown', finish, true);
    window.addEventListener('resize', finish);
    window.addEventListener('pagehide', finish);
    section?.addEventListener('shopify:section:unload', finish);
    if (reduced.matches || document.hidden || !headings.length) { finish(); return; }
    const rect = headings[0].getBoundingClientRect();
    if (rect.bottom > 0 && rect.top < innerHeight) {
      enter();
    } else if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) enter();
        else if (started) finish();
      });
      observer.observe(headings[0]);
    } else { finish(); }
  }

  document.querySelectorAll(selector).forEach(initHeading);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll(selector).forEach(initHeading));
})();
